<template>
  <!-- 输入搜索区域 -->
  <div class="top-search-area">
    <div class="search-input-block" :style="{ marginLeft: isBigEngineer ? '-160px' : '-75px' }">
      <!-- 搜索输入框 -->
      <div
        class="search-input"
        :style="{
          height: inputHeight + 'px',
          width: searchInputWidth + 'px',
          borderRadius: inputHeight + 'px',
        }"
      >
        <input
          type="text"
          placeholder="输入你想搜索的内容"
          v-model="keyword"
          @focus="dropOpen"
          :style="{ 'font-size': fontSize + 'px' }"
          @input="getDataSource();loading = true;"
          @keypress.enter="freshSearch('auto')"
          @blur="_blur"
        />
        <i
          class="el-icon el-icon-close simple-click-hover"
          color="#000000"
          :size="20"
          v-show="keyword"
          @click="keyword = '';dropClose()"
        ></i>
        <div
          class="search-confirm-button simple-click-hover"
          :style="{
            height: inputHeight + 'px',
            'line-height': inputHeight + 'px',
            'border-top-right-radius': inputHeight + 'px',
            'border-bottom-right-radius': inputHeight + 'px',
            'font-size': fontSize + 'px',
          }"
          @click="freshSearch('lib')"
        >
          搜产品
        </div>

        <div
          class="search-company-btn"
          :style="{
            height: inputHeight + 'px',
            'line-height': inputHeight + 'px',
            'font-size': fontSize + 'px',
            backgroundImage: companyBtnImgBg,
          }"
          @click="freshSearch('comp')"
        >搜企业</div>

        <div v-if="isBigEngineer" class="search-standard-btn" :style="{ height: inputHeight + 'px', 'line-height': inputHeight + 'px', 'font-size': fontSize + 'px', backgroundImage: companyBtnImgBg, color: 'red' }" @click="openStandard">材智库</div>
      </div>

      

      <!-- 联想词（悬浮窗） -->
      <div
        :style="dropDownStyle"
        class="ass-word suspension-block"
        v-loading="loading"
        v-show="(keyword && isOpen) && dataSource.length"
      >
        <div class="suspension-content">
          <div
            class="suspension-item"
            :data-value="item"
            :style="{
              'font-size': fontSize + 'px',
            }"
            v-for="(item, index) of dataSource"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
      
      <!-- 搜索历史（悬浮窗） -->
      <div
        :style="dropDownStyle"
        class="history-word suspension-block"
        v-show="!keyword && (isOpen) && historys.length"
      >
        <div
          class="history-word-title"
          :style="{
            'font-size': fontSize - 2 + 'px',
          }"
        >
          搜索历史

          <div class="clear-all" @click="clearSearchHistory">清除所有记录</div>
        </div>
        <div class="suspension-content">
          <div
            class="suspension-item"
            :data-value="item"
            :style="{
              'font-size': fontSize + 'px',
            }"
            v-for="(item, index) of historys"
            :key="index"
          >
            {{ item }}

            <i class="el-icon-close" @click.stop="delHistry(index)"></i>
          </div>
        </div>
      </div>
    </div>
    <kyb-use-dialog v-if="isClient"></kyb-use-dialog>
    <!-- <big-engineer-use-dialog v-if="!isClient"></big-engineer-use-dialog> -->
    <std-vip-dialog :visible="stdVipVisible" @close="stdVipVisible = false" />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import {CheckLibs} from '@digital-supply-chain/module'

import { TodaySearchService, Message, OpenService, DataService } from "@/service";
import { Listener, DomainService, ApiService, WinForm } from "@/libs";

import KybUseDialog from './kyb-use-dialog.vue'
import BigEngineerUseDialog from './big-engineer-use-dialog.vue'
import StdVipDialog from './std-vip-dialog.vue'

export default {
  props: {
    inputHeight: { type: [Number, String], default: 40 }, // 搜索框的宽
    searchInputWidth: { type: [Number, String], default: 500 }, // 搜索框的高
    fontSize: { type: [Number, String], default: 14 }, // 搜索框字体大小
    openNew: { default: false }, // 搜索是否打开新的页面
  },
  components: {KybUseDialog,BigEngineerUseDialog,StdVipDialog},
  data() {
    return {
      keyword: "",
      loading: false,
      dataSource: [], // 关联词
      isOpen: false,
      stdVipVisible: false, // 标准材智库会员提示弹窗

      companyBtnImgBg: `url(${DomainService.PublicPath}resource/images/icon/comp-search.png)`,

      isClient: CheckLibs.isClient(),
      isBigEngineer: CheckLibs.isBigEngineer() || CheckLibs.isBigEngineerE(), // 是否大工程师个人版或企业版
    };
  },
  computed: {
    ...mapGetters({
      historys:'search/historys',
    }),
    dropDownStyle() {
      return {
        top: this.inputHeight + 'px',
        width: this.searchInputWidth - 94 + 'px',
      }
    }
  },
  mounted() {
    // 弹框列表出现后，点击其他任意位置，弹框缩回
    Listener.bodyEventDelegate(['suspension-item'], 'search-input-block', (obj) => {
      if (obj.type === 'white_click') {
        this.selectHandle(obj.dataset.value);
      }
      if (obj.type === 'out_click') {
        this.dropClose();
      }
    });
  },
  methods: {
    ...mapMutations({
      delHistry: 'search/delHistry',
      clearSearchHistory: 'search/clearSearchHistory',
    }),

    _blur(e) {
      if (!(e.sourceCapabilities)) {
        this.dropClose();
      }
    },
    dropOpen(e) {
      if (!e.sourceCapabilities) {
        e.target.blur();
        return false;
      }
      this.isOpen = true;
    },
    dropClose() {
      this.isOpen = false;
    },

    getDataSource: debounce(
      function () {
        this.getSearchKeyword();
      },
      500,
      false
    ),
    // 搜索关键词(联想词)
    async getSearchKeyword() {
      const res = await TodaySearchService.getSearchKeyword(this.keyword);
      if (res.code === 0) {
        this.dataSource = res.data;
      }
      this.loading = false;
    },
    selectHandle(_item) {
      this.keyword = _item;
      this.dropClose();
      this.freshSearch('auto');
    },
    // ----------- 打开搜标准新标签页
    async openStandard() {

      // 先查是否是联合会员/还有试用次数，不是且次数用尽则弹窗拦截
      try {
        const vipRes = await DataService.get(`${ApiService.ProfitApi}/user/getSvipTrial`);
        const vip = vipRes?.data || {};
        const isVip = vip.isSuperVip === 1;
        const hasTrial = (vip.remaining || 0) > 0;
        if (!isVip && !hasTrial) {
          this.stdVipVisible = true;
          return;
        }
      } catch (e) {
        // 查询会员状态失败时放行，不阻断用户
        return
      }

      // 再调接口拿 sso code，拼到 url 上跳转
      try {
        const res = await DataService.post(`${ApiService.JrzzApi80}/sso/code/apply`, { client_id: '10000012' });
        const code = res?.data?.code || '';
        if (!code) {
          return Message.warning('生成授权码失败，请重试');
        }
        // const url = `http://localhost:5190/?code=${code}`;
        const url = `http://115.120.194.81:82/?code=${code}`;
        // const url = `https://cad-preview.gongpinlian.com/?fileId=a1e805f2-7e7f-4474-a95a-a7da94c56ae5`;
        // 客户端内新开标签页打开；非客户端走浏览器新标签页
        if (this.isClient && WinForm.md?.openTab) {
          WinForm.md.openTab(url, '标准材智库');
        } else {
          window.open(url);
        }
      } catch (e) {
        Message.warning('生成授权码失败，请重试');
      }
    },
    // 重新搜索
    freshSearch(type = 'lib') {
      if (!this.keyword) {
        return Message.warning("请输入想搜索的内容!");
      }

      let typeString = type;
      if (typeString === 'auto') {
        location.pathname.includes('/search/comp') && (typeString = 'comp');
        location.pathname.includes('/search/lib') && (typeString = 'lib');
      }
      typeString === 'auto' && (typeString = 'lib')

      this.dropClose();
      let queryString = '';
      const { compId, compName } = this.$route.query;
      if (compId) {
        queryString = `?compId=${compId}&compName=${compName}`
      }
      if (this.openNew) {
        setTimeout(() => {
          OpenService.openSearchLib(this.keyword, this.openNew, queryString, typeString);
        }, 300)
      } else {
        OpenService.openSearchLib(this.keyword, this.openNew, queryString, typeString);
      }
    },
  },
};

/**
 * @desc 函数防抖
 * @param fn 函数
 * @param timerDelay 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
export function debounce(fn, timerDelay, immediate) {
  let timer;
  return function () {
    let that = this;
    let args = arguments;
    if (timer) clearTimeout(timer);
    if (immediate) {
      var callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, timerDelay);
      if (callNow) fn.apply(that, args);
    } else {
      timer = setTimeout(function () {
        fn.apply(that, args);
      }, timerDelay);
    }
  };
}
</script>
<style lang="less" scoped>
.clear-all{
  position: absolute;
  right: 12px;
  top: 10px;
  line-height: 20px;
  cursor: pointer;
}

.el-icon-close{
  position: absolute;
  right: 6px;
  top: 7px;
  width: 26px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  font-size: 18px;
  cursor: pointer;
}
.top-search-area {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 998;
  width: 900px;
  margin: 0 auto;
  // margin: 16px 0 24px;
}

// 搜索输入框区域
.search-input-block {
  position: relative;
  display: flex;
  align-items: center;

  .search-input {
    display: flex;
    align-items: center;
    padding: 0 75px 0 25px;
    border: 2px solid #0989C5;
    background-color: #ffffff;
  }

  input {
    flex: 1;
    line-height: 1.5;
    border: none;
    outline: none;
    color: @text-color-base;

    &::placeholder {
      color: #cfcece;
    }
  }
}

// 搜索按钮
.search-confirm-button {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  background: @a-color-active;
  color: #ffffff;
}

.search-company-btn{
  width: 80px;
  background-size: 100% 100%;
  padding-left: 22px;
  color: @a-color-active;
  font-weight: bold;
  position: absolute;
  right: -75px;
  cursor: pointer;
}

.search-standard-btn{
  width: 80px;
  background-size: 100% 100%;
  padding-left: 22px;
  color: @a-color-active;
  font-weight: bold;
  position: absolute;
  right: -150px;
  cursor: pointer;
}

// 联想词
.suspension-block {
  position: absolute;
  left: 25px;
  z-index: 10;
  padding: 5px 5px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  box-shadow: 0px 6px 21px 0px rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  box-sizing: border-box;

  .suspension-content {
    max-height: 350px;
    overflow-y: scroll;

    &::-webkit-scrollbar-track {
      background-color: white;
    }
  }

  .suspension-item {
    flex: 1;
    width: 100%;
    line-height: 40px;
    padding: 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    position: relative;

    &:hover {
      background: #fcfcfc;
    }
  }
}

.history-word-title {
  line-height: 40px;
  padding-left: 10px;
  color: @text-color-help-dark;
  position: relative;
}
</style>